import { useContext } from 'react'

import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { useSession } from '@marketplace-web/shared/session-data'

import BrazeContext from '../containers/BrazeProvider/BrazeContext'

export const useGetUserExternalId = () => {
  const fetchExternalIdEnabled = useFeatureSwitch('kk_migrate_external_id_retrieval_web')
  const brazeServiceExternalId = useContext(BrazeContext).userExternalId
  const { user } = useSession()
  const userDtoExternalId = user?.external_id

  const userExternalId = fetchExternalIdEnabled ? brazeServiceExternalId : userDtoExternalId

  return userExternalId
}
